import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import RenderTextareaInputField from 'components/form/InputFields/RenderTextareaInputField';
import TranslateButton from 'components/form/localisation/translations/TranslateButton';
import utils from 'helpers/utils';
import { Field as ReduxField } from 'redux-form';

const styles = {
    input: {
        width: '100%',
        flex: 1,
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
};

const Field = (props) => {
    const {
        fieldValidate,
        locale,
        maxLength,
        minRows,
        name,
        system,
        type,
        updateTranslation,
    } = props;

    let fieldProps = {};

    if (type === 'textarea') {
        fieldProps = {
            component: RenderTextareaInputField,
            maxLength: maxLength,
            multiLine: true,
            rows: minRows,
        };
    }

    const fetchValue = (locale, key) => {
        const { formValues } = props;

        if (utils.has(formValues, `localisation.${ locale }.${ key }`)) {
            return utils.get(formValues, `localisation.${ locale }.${ key }`);
        }

        return '';
    };

    return (
        <div style={ styles.inputWrapper }>
            <ReduxField
                className='input'
                component={ RenderTextInputField }
                label={ utils.firstCharToCamelCase(utils.formatPropertyName(name)) }
                name={ `localisation.[${ locale }].${ name }` }
                placeholder={ utils.formatPropertyName(name) }
                style={ styles.input }
                type='text'
                validate={ fieldValidate(locale, name) }
                { ...fieldProps }
            />

            {
                locale !== system &&
                    <TranslateButton
                        name={ name }
                        sourceLanguage={ system }
                        sourceText={ fetchValue(system, name) }
                        targetLanguage={ locale }
                        updateTranslation={ (target, locale, name) => {
                            updateTranslation(target, locale, name);
                        } }
                    />
            }
        </div>
    );
};

Field.propTypes = {
    fieldValidate: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    locale: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
    minRows: PropTypes.number,
    name: PropTypes.string.isRequired,
    system: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    updateTranslation: PropTypes.func.isRequired,
};

export default Field;



// WEBPACK FOOTER //
// ./src/components/form/localisation/translations/FormField.js